export const answers = {
  '1': {
    a: false,
    b: false,
    c: true,
    d: false
  },
  '2': {
    a: true,
    b: false,
    c: false,
    d: false
  },
  '3': {
    a: false,
    b: false,
    c: false,
    d: true
  },
  '4': {
    a: false,
    b: true,
    c: false,
    d: false
  },
  '5': {
    a: false,
    b: false,
    c: true,
    d: false
  },
  '6': {
    a: true,
    b: false,
    c: false,
    d: false
  },
  '7': {
    a: false,
    b: false,
    c: false,
    d: true
  },
  '8': {
    a: true,
    b: false,
    c: false,
    d: false
  },
  '9': {
    a: false,
    b: true,
    c: false,
    d: false
  },
  '10': {
    a: true,
    b: false,
    c: false,
    d: false
  },
  '11': {
    a: true,
    b: false,
    c: false,
    d: false
  },
  '12': {
    a: true,
    b: false,
    c: false,
    d: false
  }
}